import { GenService } from "./gen-ser.service";

export class Deparment{
    constructor(private _depId:string,private _depName:string,private _email:string,private _orderno:number,private _isActive:boolean){

    }

    get depId():string{
        return this._depId;
    }
    get depName():string{
        return this._depName;
    }
    get email():string{
        return this._email;
    }
    get orderNo():number{
        return this._orderno;
    }
    get isActive():boolean{
        return this._isActive
    }
}

export class InspectionDoneBy{
    constructor(private _inspectionId:string,private _inspName:string,private _inspEmail:string,private _orderno:number,private _isActive:boolean){}
    get inspectionId():string{
        return this._inspectionId;
    }
    get inspName():string{
        return this._inspName;
    }
    get inspEmail():string{
        return this._inspEmail;
    }
    get orderNo():number{
        return this._orderno;
    }
    get isActive():boolean{
        return this._isActive;
    }
}

export class RespPerson{
    constructor(private _respId:string,private _respName:string,private _email:string,private _orderNo:number,private _isActive:boolean){

    }

    get respId():string{
        return this._respId;
    }
    get respName():string{
        return this._respName;
    }
    get email():string{
        return this._email;
    }
    get orderNo():number{
        return this._orderNo;
    }
    get isActive():boolean{
        return this._isActive
    }
}

export class RootCauseCategory{
    constructor(private _catRefId:string,private _catDisplayName:string,private _catCssClassId:number,
                private _catOrderNo:number){
    }

    get refId():string{
        return this._catRefId;
    }
    get displayName():string{
        return this._catDisplayName;
    }
    get cssClass():string{
        switch(this._catCssClassId){
            case 1:
                return 'fa-user';
            case 2:
                return 'fa-shopping-cart';
            case 3:
                return 'fa-tasks';
            case 4:
                return 'fa-cogs';
            case 5:
                return 'fa-tree';
        }
        return '';
    }
    get orderNo():number{
        return this._catOrderNo;
    }

}

export class Customer{
    constructor(private _custId:string,private _custName:string,private _email:string,private _orderno:number,private _isActive:boolean){

    }
    get custId():string{
        return this._custId;
    }
    get custName():string{
        return this._custName;
    }
    get email():string{
        return this._email;
    }
    get orderNo():number{
        return this._orderno;
    }
    get isActive():boolean{
        return this._isActive;
    }
}

export class ProductsList{
    constructor(private _productId:string,private _productName:string,private _productType:string,private _details:string,private _orderno:number,private _isActive:boolean){

    }
    get productId():string{
        return this._productId;
    }
    get productName():string{
        return this._productName;
    }
    get productType():string{
        return this._productType
    }
    get details():string{
        return this._details;
    }
    get orderno():number{
        return this._orderno;
    }
    get isActive():boolean{
        return this._isActive
    }
    set productId(id:string){
        this._productId = id;
    }
    set productName(nm:string){
        this._productName = nm;
    }
    set productType(id:string){
        this._productType = id
    }
    set details(dt:string){
        this._details = dt
    }
    set orderno(nm:number){
        this._orderno = nm;
    }
    set isActive(flag:boolean){
        this._isActive = flag
    }
}
export class Product{
    constructor(private _productId:string,private _productName:string,private _details:string,private _orderno:number,private _isActive:boolean){

    }
    get productId():string{
        return this._productId;
    }
    get productName():string{
        return this._productName;
    }
    get details():string{
        return this._details;
    }
    get orderno():number{
        return this._orderno;
    }
    get isActive():boolean{
        return this._isActive
    }
    set productId(id:string){
        this._productId = id;
    }
    set productName(nm:string){
        this._productName = nm;
    }
    set details(dt:string){
        this._details = dt
    }
    set orderno(nm:number){
        this._orderno = nm;
    }
    set isActive(flag:boolean){
        this._isActive = flag
    }
}

export class subProduct{
    constructor(private _productId:string,private _subProductName:string,private _subProductId:string,private _details:string,private _orderno:number,private _isActive:boolean){

    }
    get productId():string{
        return this._productId;
    }
    get subProductName():string{
        return this._subProductName;
    }
    get subProductId():string{
        return this._subProductId;
    }
    get details():string{
        return this._details;
    }
    get orderNo():number{
        return this._orderno;
    }
    get isActive():boolean{
        return this._isActive
    }
}
export class Type{
    constructor(private _typeId:string,private _typeName:string){ }
    get typeId():string{
        return this._typeId;
    }
    get typeName():string{
        return this._typeName;
    }
}

export class PolePart{
    constructor(private _poleId:string, private _partDesc:string,private _productId:string,private _orderno:number,private _isActive:boolean){ }

    get poleId():string{
        return this._poleId;
    }
    get partDescription():string{
        return this._partDesc;
    }
    get productId():string{
        return this._productId
    }
    get orderNo():number{
        return this._orderno;
    }
    get isActive():boolean{
        return this._isActive;
    }
    set poleId(id:string){
        this._poleId = id
    }
    set partDescription(desc:string){
        this._partDesc = desc;
    }
    set productId(id:string){
        this._productId = id;
    }
    set orderNo(no:number){
        this._orderno = no;
    }
    set isActive(flag:boolean){
        this._isActive = flag;
    }
    cloneSelf():PolePart{
        return new PolePart(this._poleId,this._partDesc,this._productId,this._orderno,this._isActive);
    }
}
export class PoleELPart {
    constructor(private _poleELPartId: string, private _poleELName: string, private _poleELTypeId: string, private _orderNo: number, private _isActive: boolean) {

    }

    get PoleELPartId(): string {
        return this._poleELPartId;
    }
    get PoleELName(): string {
        return this._poleELName;
    }
    get ELTypeId(): string {
        return this._poleELTypeId;
    }
    get OrderNo(): number {
        if(this._orderNo)
            return this._orderNo;
        return 1;
    }
    get IsActive(): boolean {
        return this._isActive;
    }

    set PoleELPartId(_setVal: string) {
        this._poleELPartId = _setVal;
    }
    set PoleELName(_setVal: string) {
        this._poleELName = _setVal;
    }
    set ELTypeId(_setVal:string){
        this._poleELTypeId = _setVal;
    }
    set OrderNo(_tmpOrderNo: number) {
        this._orderNo = _tmpOrderNo;
    }
    set IsActive(_tempIsActive: boolean) {
        this._isActive = _tempIsActive;
    }

    cloneSelf():PoleELPart {
        return new PoleELPart(this._poleELPartId, this._poleELName, this._poleELTypeId, this._orderNo, this._isActive);
    }

}

export class Plan{
    constructor(private _monthDateNum:number,private _description:string,private _docTs:number){}
    get monthDateNum():number{
        return this._monthDateNum;
    }
    get description():string{
        return this._description
    }
    get docTs():number{
        return this._docTs;
    }
    // get productLineId():string{
    //     return this._productLineId;
    // }
    set monthDateNum(nm:number){
        this._monthDateNum = nm;
    }
    set description(des:string){
        this._description = des;
    }
    // set productLineId(id: string) {
    //     this._productLineId = id;
    // }
}

export class MaterialGembaCard{
    constructor(private _id:string,private _monthDateNum:number,private _plan:string,private _dayTokens:Array<MaterialDayToken>){

    }
    get isNew():boolean{
        return this._id == '';
    }
    get id():string{
        return this._id;
    }
    get monthDateNum():number{
        return this._monthDateNum;
    }
    get monthDate():Date{
        if(this._monthDateNum>0) return new Date(this._monthDateNum);
        return null;
    }
    get plan():string{
        return this._plan;
    }
    get dayTokens():Array<MaterialDayToken>{
        return this._dayTokens;
    }
    set id(id:string){
        this._id = id;
    }
    set monthDateNum(_mName:number){
        this._monthDateNum = _mName;
    }
    set plan(_p:string){
        this._plan = _p;
    }
    set dayTokens(_dTokens:Array<MaterialDayToken>){
        this._dayTokens = _dTokens;
    }

    addDateToken(_daySelected:Date,_dToken:MaterialToken = null){        
        let _tmpDate:Date = new Date(_daySelected.getTime());
        let _tmpIndex:number = this._dayTokens.findIndex((_tmpObj:MaterialDayToken) => {
            return _tmpObj.selDate.getDate() == _tmpDate.getDate() &&
                   _tmpObj.selDate.getMonth() == _tmpDate.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _tmpDate.getFullYear();
        });
        if(_tmpIndex >= 0){
            if(_dToken!=null)
                this._dayTokens[_tmpIndex].addToken(_dToken);
        }
        else{
            if(_dToken!=null)
                this._dayTokens.push(new MaterialDayToken(_tmpDate,[_dToken]));
            else 
                this._dayTokens.push(new MaterialDayToken(_tmpDate,[]));

       }
    }

    getDateToken(_daySelected:Date):MaterialDayToken{
        return this._dayTokens.find((_tmpObj:MaterialDayToken) => {
            return _tmpObj.selDate.getDate() == _daySelected.getDate() &&
                   _tmpObj.selDate.getMonth() == _daySelected.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _daySelected.getFullYear();
        });
    }

}

export class MaterialDayToken{
    constructor(private _selDate:Date,private _tokens:Array<MaterialToken>){}

    get selDate():Date{
        return this._selDate;
    }
    get dateTokens():Array<MaterialToken>{
        return this._tokens;
    }
    set dateTokens(_tmpTokens:Array<MaterialToken>){
        this._tokens = _tmpTokens;
    }
    addToken(_tmpToken:MaterialToken){
        this._tokens.push(_tmpToken);
    }
    removeToken(_tokenIndex:number){
        if(_tokenIndex >= 0 && _tokenIndex < this._tokens.length)
            this._tokens.splice(_tokenIndex, 1);
    }
}

export class MaterialToken{
    public _date:Date;
    public _creationDate:Date;
    public _isSeverityModified:boolean = false;
    constructor(private _rowId:string,private _productId:string,private _productType:string, private _customerId:string,
                private _quantity:number,private _shortage:string,private _status:string,private _creationDateNum:number,private _shortageNotes:string,
                private _severityValue:SeverityStatus, private _selDate:Date, private _severitySource:string){ 
    }
    get rowId():string{
        return this._rowId;
    }
    get productType():string{
        return this._productType
    }
    get shortage():string{
        return this._shortage
    }
    get productId():string{
        return this._productId;
    }
    get customerId():string{
        return this._customerId;
    }
    get quantity():number{
        return this._quantity;
    }
    get creationDate():number{         
        return this._creationDateNum;
    }
    get createdDate():Date{
        if(this._creationDateNum>0) return new Date(this._creationDateNum);
        return null;
    }
    get statusDate():Date{
        return this._selDate;
    }
    get status():string{
        return this._status;
    }
    get shortageNotes():string{
        return this._shortageNotes
    }
    get severityValue():SeverityStatus{
        return this._severityValue
    }
    get severitySource():string{
        return this._severitySource;
    }
    get severitySourceDispName():string{
        if(this._severitySource == 'production') return "Production";
        if(this._severitySource == 'green_sticker') return "Green Sticker";
        return "";
    }
    set productType(st:string){
        this._productType = st;
    }
    set shortage(st:string){
        this._shortage= st;
    }
    set productId(_pid:string){
        this._productId = _pid;
    }
    set customerId(_cid:string){
        this._customerId = _cid;
    }
    set quantity(_q:number){
        this._quantity = _q;
    }
    set status(st:string){
        this._status = st;
    }
    set creationDate(dt:number){
        this._creationDateNum = dt;
        this._creationDate = new Date(dt);
    }
    set shortageNotes(st:string){
        this._shortageNotes = st;
    }
    set severityValue(SetVal:SeverityStatus){
        this._isSeverityModified = true;
        this._severityValue = SetVal;
    }

    cloneSelf():MaterialToken{
        let _tmpObj:MaterialToken = new MaterialToken(this.rowId, this._productId,this._productType,this._customerId,this._quantity,this._shortage, this._status,this._creationDateNum,this._shortageNotes,this._severityValue,this.statusDate,this.severitySource);
        return _tmpObj;
    }
}




export class DailyProdHighlights{
    constructor(private _id:string,private _monthDateNum:number,private _plan:string,private _dayTokens:Array<DPHDayToken>,
                private _docTs:number){

    }
    get isNew():boolean{
        return this._id == '';
    }
    get id():string{
        return this._id;
    }
    get monthDateNum():number{
        return this._monthDateNum;
    }
    get monthDate():Date{
        if(this._monthDateNum>0) return new Date(this._monthDateNum);
        return null;
    }
    get plan():string{
        return this._plan;
    }
    get dayTokens():Array<DPHDayToken>{
        return this._dayTokens;
    }
    set id(id:string){
        this._id = id;
    }
    set monthDateNum(_mName:number){
        this._monthDateNum = _mName;
    }
    set plan(_p:string){
        this._plan = _p;
    }
    set dayTokens(_dTokens:Array<DPHDayToken>){
        this._dayTokens = _dTokens;
    }
    get docTs():number{
        return this._docTs;
    }

    addDateToken(_daySelected:Date,_dToken:DPHToken = null){        
        let _tmpDate:Date = new Date(_daySelected.getTime());
        let _tmpIndex:number = this._dayTokens.findIndex((_tmpObj:DPHDayToken) => {
            return _tmpObj.selDate.getDate() == _tmpDate.getDate() &&
                   _tmpObj.selDate.getMonth() == _tmpDate.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _tmpDate.getFullYear();
        });
        if(_tmpIndex >= 0){
            if(_dToken!=null)
                this._dayTokens[_tmpIndex].addToken(_dToken);
        }
        else{
            if(_dToken!=null)
                this._dayTokens.push(new DPHDayToken(_tmpDate,[_dToken]));
            else 
                this._dayTokens.push(new DPHDayToken(_tmpDate,[]));

       }
    }

    getDateToken(_daySelected:Date):DPHDayToken{
        return this._dayTokens.find((_tmpObj:DPHDayToken) => {
            return _tmpObj.selDate.getDate() == _daySelected.getDate() &&
                   _tmpObj.selDate.getMonth() == _daySelected.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _daySelected.getFullYear();
        });
    }

}

export class DPHDayToken{
    constructor(private _selDate:Date,private _tokens:Array<DPHToken>){}

    get selDate():Date{
        return this._selDate;
    }
    get dateTokens():Array<DPHToken>{
        return this._tokens;
    }
    set dateTokens(_tmpTokens:Array<DPHToken>){
        this._tokens = _tmpTokens;
    }
    addToken(_tmpToken:DPHToken){
        this._tokens.push(_tmpToken);
    }
    removeToken(_tokenIndex:number){
        if(_tokenIndex >= 0 && _tokenIndex < this._tokens.length)
            this._tokens.splice(_tokenIndex, 1);
    }
}

export class MaterialShortage{
    constructor(private _id:string,private _monthDateNum:number,private _plan:string,private _dayTokens:Array<MSCDayToken>,private _docTs:number){

    }
    get isNew():boolean{
        return this._id == '';
    }
    get id():string{
        return this._id;
    }
    get monthDateNum():number{
        return this._monthDateNum;
    }
    get monthDate():Date{
        if(this._monthDateNum>0) return new Date(this._monthDateNum);
        return null;
    }
    get plan():string{
        return this._plan;
    }
    get dayTokens():Array<MSCDayToken>{
        return this._dayTokens;
    }
    get docTs():number{
        return this._docTs
    }
    set monthDateNum(_mName:number){
        this._monthDateNum = _mName;
    }
    set plan(_p:string){
        this._plan = _p;
    }
    set dayTokens(_dTokens:Array<MSCDayToken>){
        this._dayTokens = _dTokens;
    }

    addDateToken(_daySelected:Date,_dToken:MSCToken = null){        
        let _tmpDate:Date = new Date(_daySelected.getTime());
        let _tmpIndex:number = this._dayTokens.findIndex((_tmpObj:MSCDayToken) => {
            return _tmpObj.selDate.getDate() == _tmpDate.getDate() &&
                   _tmpObj.selDate.getMonth() == _tmpDate.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _tmpDate.getFullYear();
        });
        if(_tmpIndex >= 0){
            if(_dToken!=null)
                this._dayTokens[_tmpIndex].addToken(_dToken);
        }
        else{
            if(_dToken!=null)
                this._dayTokens.push(new MSCDayToken(_tmpDate,[_dToken]));
            else 
                this._dayTokens.push(new MSCDayToken(_tmpDate,[]));

       }
    }

    getDateToken(_daySelected:Date):MSCDayToken{
        return this._dayTokens.find((_tmpObj:MSCDayToken) => {
            return _tmpObj.selDate.getDate() == _daySelected.getDate() &&
                   _tmpObj.selDate.getMonth() == _daySelected.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _daySelected.getFullYear();
        });
    }
}

export class MSCDayToken{
    constructor(private _selDate:Date,private _tokens:Array<MSCToken>){

    }

    get selDate():Date{
        return this._selDate;
    }
    get dateTokens():Array<MSCToken>{
        return this._tokens;
    }
    set dateTokens(_tmpTokens:Array<MSCToken>){
        this._tokens = _tmpTokens;
    }
    addToken(_tmpToken:MSCToken){
        this._tokens.push(_tmpToken);
    }
    removeToken(_tokenIndex:number){
        if(_tokenIndex >= 0 && _tokenIndex < this._tokens.length)
            this._tokens.splice(_tokenIndex, 1);
    }
}

export class DailyDeliveryPlan{
    constructor(private _id:string,private _monthDateNum:number,private _plan:string,private _dayTokens:Array<DSPDayToken>,private _docTs:number){

    }
    get isNew():boolean{
        return this._id == '';
    }
    get id():string{
        return this._id;
    }
    get monthDateNum():number{
        return this._monthDateNum;
    }
    get monthDate():Date{
        if(this._monthDateNum>0) return new Date(this._monthDateNum);
        return null;
    }
    get plan():string{
        return this._plan;
    }
    get dayTokens():Array<DSPDayToken>{
        return this._dayTokens;
    }
    get docTs():number{
        return this._docTs
    }
    set monthDateNum(_mName:number){
        this._monthDateNum = _mName;
    }
    set plan(_p:string){
        this._plan = _p;
    }
    set dayTokens(_dTokens:Array<DSPDayToken>){
        this._dayTokens = _dTokens;
    }

    addDateToken(_daySelected:Date,_dToken:DSPToken = null){
        let _tmpDate:Date = new Date(_daySelected.getTime());
        let _tmpIndex:number = this._dayTokens.findIndex((_tmpObj:DSPDayToken) => {
            return _tmpObj.selDate.getDate() == _tmpDate.getDate() &&
                   _tmpObj.selDate.getMonth() == _tmpDate.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _tmpDate.getFullYear();
        });
        if(_tmpIndex >= 0){
            if(_dToken!=null)
                this._dayTokens[_tmpIndex].addToken(_dToken);
        }
        else{
            if(_dToken!=null)
                this._dayTokens.push(new DSPDayToken(_tmpDate,[_dToken]));
            else 
                this._dayTokens.push(new DSPDayToken(_tmpDate,[]));

       }
    }

    getDateToken(_daySelected:Date):DSPDayToken{
        return this._dayTokens.find((_tmpObj:DSPDayToken) => {
            return _tmpObj.selDate.getDate() == _daySelected.getDate() &&
                   _tmpObj.selDate.getMonth() == _daySelected.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _daySelected.getFullYear();
        });
    }
}

export class DSPDayToken{
    constructor(private _selDate:Date,private _tokens:Array<DSPToken>){}

    get selDate():Date{
        return this._selDate;
    }
    get dateTokens():Array<DSPToken>{
        return this._tokens;
    }
    set dateTokens(_tmpTokens:Array<DSPToken>){
        this._tokens = _tmpTokens;
    }
    addToken(_tmpToken:DSPToken){
        this._tokens.push(_tmpToken);
    }
    removeToken(_tokenIndex:number){
        if(_tokenIndex >= 0 && _tokenIndex < this._tokens.length)
            this._tokens.splice(_tokenIndex, 1);
    }
}

export class CCRPDayToken{
    constructor(private _selDate:Date,private _tillDateRaisedCCRP:string,private _tillDateClosedCCRP:string,
        private _openCCRPOnDate:string,private _CCRPOpenForMaterials:string,private _CCRPOpenServiceEng:string,
        private _CCRPWaitingForClosure:string,private _tokens:Array<CCRPSMToken>){}
    
        get selDate():Date{
            return this._selDate;
        }
        get dateTokens():Array<CCRPSMToken>{
            return this._tokens;
        }
        get tillDateRaisedCCRP():string{
            return this._tillDateRaisedCCRP;
        }
        get tillDateClosedCCRP():string{
            return this._tillDateClosedCCRP;
        }
        get openCCRPOnDate():string{
            return this._openCCRPOnDate;
        }
        get CCRPOpenForMaterials():string{
            return this._CCRPOpenForMaterials;
        }
        get CCRPOpenServiceEng():string{
            return this._CCRPOpenServiceEng;
        }
        get CCRPWaitingForClosure():string{
            return this._CCRPWaitingForClosure;
        }
        set dateTokens(_tmpTokens:Array<CCRPSMToken>){
            this._tokens = _tmpTokens;
        }
        set CCRPWaitingForClosure(_wat:string){
            this._CCRPWaitingForClosure = _wat;
        }
        set CCRPOpenServiceEng(_eng:string){
            this._CCRPOpenServiceEng=_eng;
        }
        set CCRPOpenForMaterials(_mat:string){
            this._CCRPOpenForMaterials=_mat;
        }
        set openCCRPOnDate(_op:string){
            this._openCCRPOnDate=_op;
        }
        set tillDateClosedCCRP(_col:string){
            this._tillDateClosedCCRP = _col;
        }
        set tillDateRaisedCCRP(_pl:string){
            this._tillDateRaisedCCRP = _pl
        }
        addToken(_tmpToken:CCRPSMToken){
            this._tokens.push(_tmpToken);
        }
        removeToken(_tokenIndex:number){
            if(_tokenIndex >= 0 && _tokenIndex < this._tokens.length)
                this._tokens.splice(_tokenIndex, 1);
        }
}
export class CustomerInspectionPlan{
    constructor(private _id:string,private _monthDateNum:number,private _plan:string,private _dayTokens:Array<CIPDayToken>,private _docTs:number){

    }
    get isNew():boolean{
        return this._id == '';
    }
    get id():string{
        return this._id;
    }
    get monthDateNum():number{
        return this._monthDateNum;
    }
    get monthDate():Date{
        if(this._monthDateNum>0) return new Date(this._monthDateNum);
        return null;
    }
    get plan():string{
        return this._plan;
    }
    get dayTokens():Array<CIPDayToken>{
        return this._dayTokens;
    }
    get docTs():number{
        return this._docTs;
    }
    set monthDateNum(_mName:number){
        this._monthDateNum = _mName;
    }
    set plan(_p:string){
        this._plan = _p;
    }
    set dayTokens(_dTokens:Array<CIPDayToken>){
        this._dayTokens = _dTokens;
    }

    addDateToken(_daySelected:Date,_dToken:CIPToken = null){
        let _tmpDate:Date = new Date(_daySelected.getTime());
        let _tmpIndex:number = this._dayTokens.findIndex((_tmpObj:CIPDayToken) => {
            return _tmpObj.selDate.getDate() == _tmpDate.getDate() &&
                   _tmpObj.selDate.getMonth() == _tmpDate.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _tmpDate.getFullYear();
        });
        if(_tmpIndex >= 0){
            if(_dToken!=null)
                this._dayTokens[_tmpIndex].addToken(_dToken);
        }
        else{
            if(_dToken!=null)
                this._dayTokens.push(new CIPDayToken(_tmpDate,[_dToken]));
            else 
                this._dayTokens.push(new CIPDayToken(_tmpDate,[]));

       }
    }

    getDateToken(_daySelected:Date):CIPDayToken{
        return this._dayTokens.find((_tmpObj:CIPDayToken) => {
            return _tmpObj.selDate.getDate() == _daySelected.getDate() &&
                   _tmpObj.selDate.getMonth() == _daySelected.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _daySelected.getFullYear();
        });
    }
}

export class CIPDayToken{
    constructor(private _selDate:Date,private _tokens:Array<CIPToken>){

    }

    get selDate():Date{
        return this._selDate;
    }
    get dateTokens():Array<CIPToken>{
        return this._tokens;
    }
    set dateTokens(_tmpTokens:Array<CIPToken>){
        this._tokens = _tmpTokens;
    }
    addToken(_tmpToken:CIPToken){
        this._tokens.push(_tmpToken);
    }
    removeToken(_tokenIndex:number){
        if(_tokenIndex >= 0 && _tokenIndex < this._tokens.length)
            this._tokens.splice(_tokenIndex, 1);
    }
}

export class GreenStickerPlan{
    constructor(private _id:string,private _monthDateNum:number,private _plan:string,private _dayTokens:Array<GSPDayToken>,private _docTs:number){ }
    get isNew():boolean{
        return this._id == '';
    }
    get id():string{
        return this._id;
    }
    get monthDateNum():number{
        return this._monthDateNum;
    }
    get monthDate():Date{
        if(this._monthDateNum>0) return new Date(this._monthDateNum);
        return null;
    }
    get plan():string{
        return this._plan;
    }
    get dayTokens():Array<GSPDayToken>{
        return this._dayTokens;
    }
    get docTs():number{
        return this._docTs;
    }
    set monthDateNum(_mName:number){
        this._monthDateNum = _mName;
    }
    set plan(_p:string){
        this._plan = _p;
    }
    set dayTokens(_dTokens:Array<GSPDayToken>){
        this._dayTokens = _dTokens;
    }

    addDateToken(_daySelected:Date,_dToken:GSPToken = null){
        let _tmpDate:Date = new Date(_daySelected.getTime());
        let _tmpIndex:number = this._dayTokens.findIndex((_tmpObj:GSPDayToken) => {
            return _tmpObj.selDate.getDate() == _tmpDate.getDate() &&
                   _tmpObj.selDate.getMonth() == _tmpDate.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _tmpDate.getFullYear();
        });
        if(_tmpIndex >= 0){
            if(_dToken!=null)
                this._dayTokens[_tmpIndex].addToken(_dToken);
        }
        else{
            if(_dToken!=null)
                this._dayTokens.push(new GSPDayToken(_tmpDate,[_dToken]));
            else 
                this._dayTokens.push(new GSPDayToken(_tmpDate,[]));

       }
    }

    getDateToken(_daySelected:Date):GSPDayToken{
        return this._dayTokens.find((_tmpObj:GSPDayToken) => {
            return _tmpObj.selDate.getDate() == _daySelected.getDate() &&
                   _tmpObj.selDate.getMonth() == _daySelected.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _daySelected.getFullYear();
        });
    }
}
export class GSPDayToken{
    constructor(private _selDate:Date,private _tokens:Array<GSPToken>){

    }

    get selDate():Date{
        return this._selDate;
    }
    get dateTokens():Array<GSPToken>{
        return this._tokens;
    }
    set dateTokens(_tmpTokens:Array<GSPToken>){
        this._tokens = _tmpTokens;
    }
    addToken(_tmpToken:GSPToken){
        this._tokens.push(_tmpToken);
    }
    removeToken(_tokenIndex:number){
        if(_tokenIndex >= 0 && _tokenIndex < this._tokens.length)
            this._tokens.splice(_tokenIndex, 1);
    }
}

export class InprocessQualityIssues{
    private _monthDate:Date;
    constructor(private _id:string,private _monthDateNum:number,private _dayTokens:Array<IQIDayToken>,private _docTs:number){ }
    get isNew():boolean{
        return this._id == '';
    }
    get id():string{
        return this._id;
    }    
    get monthDateNum():number{
        return this._monthDateNum;
    }
    get monthDate():Date{
        if(this._monthDateNum>0) return new Date(this._monthDateNum);
        return null;
    } 
    get dayTokens():Array<IQIDayToken>{
        return this._dayTokens;
    }
    get docTs():number{
        return this._docTs;
    }
    set dayTokens(_dTokens:Array<IQIDayToken>){
        this._dayTokens = _dTokens;
    }
    set monthDateNum(_dtNum:number){
        this._monthDateNum = _dtNum;
    }
    set monthDate(date:Date){
        this._monthDate = date;
        this._monthDateNum = date.getTime();
    }
    addDateToken(_daySelected:Date,_dToken:IQIToken = null){
        let _tmpDate:Date = new Date(_daySelected.getTime());
        let _tmpIndex:number = this._dayTokens.findIndex((_tmpObj:IQIDayToken) => {
            return _tmpObj.selDate.getDate() == _tmpDate.getDate() &&
                   _tmpObj.selDate.getMonth() == _tmpDate.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _tmpDate.getFullYear();
        });
        if(_tmpIndex >= 0){
            if(_dToken!=null)
                this._dayTokens[_tmpIndex].addToken(_dToken);
        }
        else{
            if(_dToken!=null)
                this._dayTokens.push(new IQIDayToken(_tmpDate,[_dToken]));
            else 
                this._dayTokens.push(new IQIDayToken(_tmpDate,[]));

       }
    }

    getDateToken(_daySelected:Date):IQIDayToken{
        return this._dayTokens.find((_tmpObj:IQIDayToken) => {
            return _tmpObj.selDate.getDate() == _daySelected.getDate() &&
                   _tmpObj.selDate.getMonth() == _daySelected.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _daySelected.getFullYear();
        });
    }
}
export class IQIDayToken{
    constructor(private _selDate:Date,private _tokens:Array<IQIToken>){}
    get selDate():Date{
        return this._selDate;
    }
    get dateTokens():Array<IQIToken>{
        return this._tokens;
    }
    set dateTokens(_tmpTokens:Array<IQIToken>){
        this._tokens = _tmpTokens;
    }
    addToken(_tmpToken:IQIToken){
        this._tokens.push(_tmpToken);
    }
    removeToken(_tokenIndex:number){
        if(_tokenIndex >= 0 && _tokenIndex < this._tokens.length)
            this._tokens.splice(_tokenIndex, 1);
    }
}
export class CCRPStatusMonitoring{
    private _monthDate:Date;
    constructor(private _id:string,private _monthDateNum:number,private _dayTokens:Array<CCRPDayToken>,private _docTs:number){ }
    get isNew():boolean{
        return this._id == '';
    }
    get id():string{
        return this._id;
    }
    get monthDateNum():number{
        return this._monthDateNum;
    }
    get monthDate():Date{
        if(this._monthDateNum>0) return new Date(this._monthDateNum);
        return null;
    }  
    get dayTokens():Array<CCRPDayToken>{
        return this._dayTokens;
    }
    get docTs():number{
        return this._docTs;
    }
    set monthDateNum(_dtNum:number){
        this._monthDateNum = _dtNum;
    }
    set monthDate(date:Date){
        this._monthDate = date;
        this._monthDateNum = date.getTime();
    }
    
    set dayTokens(_dTokens:Array<CCRPDayToken>){
        this._dayTokens = _dTokens;
    }

    addDateToken(_daySelected:Date,_tillDateRaisedCCRP:string,_tillDateClosedCCRP:string,_openCCRPOnDate:string,_CCRPOpenForMaterials:string,_CCRPOpenServiceEng:string,_CCRPWaitingForClosure:string,_dToken:CCRPSMToken = null){
        let _tmpDate:Date = new Date(_daySelected.getTime());
        let _tmpIndex:number = this._dayTokens.findIndex((_tmpObj:CCRPDayToken) => {
            return _tmpObj.selDate.getDate() == _tmpDate.getDate() &&
                   _tmpObj.selDate.getMonth() == _tmpDate.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _tmpDate.getFullYear();
        });
        if(_tmpIndex >= 0){
            if(_dToken!=null)
                this._dayTokens[_tmpIndex].addToken(_dToken);
        }
        else{
            if(_dToken!=null)
                this._dayTokens.push(new CCRPDayToken(_tmpDate,_tillDateRaisedCCRP,_tillDateClosedCCRP,_openCCRPOnDate,_CCRPOpenForMaterials,_CCRPOpenServiceEng,_CCRPWaitingForClosure,[_dToken]));
            else 
                this._dayTokens.push(new CCRPDayToken(_tmpDate,_tillDateRaisedCCRP,_tillDateClosedCCRP,_openCCRPOnDate,_CCRPOpenForMaterials,_CCRPOpenServiceEng,_CCRPWaitingForClosure,[]));

       }
    }

    getDateToken(_daySelected:Date):CCRPDayToken{
        return this._dayTokens.find((_tmpObj:CCRPDayToken) => {
            return _tmpObj.selDate.getDate() == _daySelected.getDate() &&
                   _tmpObj.selDate.getMonth() == _daySelected.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _daySelected.getFullYear();
        });
    }
}

export class ProductionStatusMonitoring{
    private _monthDate:Date;
    constructor(private _id:string,private _monthDateNum:number,private _dayTokens:Array<PSMDayToken>,private _docTs:number){ }
    get isNew():boolean{
        return this._id == '';
    }
    get id():string{
        return this._id;
    }
    get monthDateNum():number{
        return this._monthDateNum;
    }
    get monthDate():Date{
        if(this._monthDateNum>0) return new Date(this._monthDateNum);
        return null;
    } 
    get dayTokens():Array<PSMDayToken>{
        return this._dayTokens;
    }
    get docTs():number{
        return this._docTs;
    }
    set monthDateNum(_dtNum:number){
        this._monthDateNum = _dtNum;
    }
    set monthDate(date:Date){
        this._monthDate = date;
        this._monthDateNum = date.getTime();
    }
    set dayTokens(_dTokens:Array<PSMDayToken>){
        this._dayTokens = _dTokens;
    }

    addDateToken(_daySelected:Date,_dToken:PSMToken = null){
        let _tmpDate:Date = new Date(_daySelected.getTime());
        let _tmpIndex:number = this._dayTokens.findIndex((_tmpObj:PSMDayToken) => {
            return _tmpObj.selDate.getDate() == _tmpDate.getDate() &&
                   _tmpObj.selDate.getMonth() == _tmpDate.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _tmpDate.getFullYear();
        });
        if(_tmpIndex >= 0){
            if(_dToken!=null)
                this._dayTokens[_tmpIndex].addToken(_dToken);
        }
        else{
            if(_dToken!=null)
                this._dayTokens.push(new PSMDayToken(_tmpDate,[_dToken],[]));
            else 
                this._dayTokens.push(new PSMDayToken(_tmpDate,[],[]));

       }
    }

    addMTSDateToken(_daySelected:Date,_dToken:PSMToken = null){
        let _tmpDate:Date = new Date(_daySelected.getTime());
        let _tmpIndex:number = this._dayTokens.findIndex((_tmpObj:PSMDayToken) => {
            return _tmpObj.selDate.getDate() == _tmpDate.getDate() &&
                   _tmpObj.selDate.getMonth() == _tmpDate.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _tmpDate.getFullYear();
        });
        if(_tmpIndex >= 0){
            if(_dToken!=null)
                this._dayTokens[_tmpIndex].addMTSToken(_dToken);
        }
        else{
            if(_dToken!=null)
                this._dayTokens.push(new PSMDayToken(_tmpDate,[],[_dToken]));
            else 
                this._dayTokens.push(new PSMDayToken(_tmpDate,[],[]));

       }
    }

    getDateToken(_daySelected:Date):PSMDayToken{
        return this._dayTokens.find((_tmpObj:PSMDayToken) => {
            return _tmpObj.selDate.getDate() == _daySelected.getDate() &&
                   _tmpObj.selDate.getMonth() == _daySelected.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _daySelected.getFullYear();
        });
    }
}
export class PSMDayToken{
    constructor(private _selDate:Date,private _tokens:Array<PSMToken>,private _mtsDateTokens:Array<PSMToken>){}
    get selDate():Date{
        return this._selDate;
    }
    get dateTokens():Array<PSMToken>{
        return this._tokens;
    }
    set dateTokens(_tmpTokens:Array<PSMToken>){
        this._tokens = _tmpTokens;
    }
    get mtsDateTokens():Array<PSMToken>{
        return this._mtsDateTokens;
    }
    set mtsDateTokens(_tmpTokens:Array<PSMToken>){
        this._mtsDateTokens = _tmpTokens;
    }

    addToken(_tmpToken:PSMToken){
        this._tokens.push(_tmpToken);
    }
    removeToken(_tokenIndex:number){
        if(_tokenIndex >= 0 && _tokenIndex < this._tokens.length)
            this._tokens.splice(_tokenIndex, 1);
    }
    addMTSToken(_tmpToken:PSMToken){
        this._mtsDateTokens.push(_tmpToken);
    }
    removeMTSToken(_tokenIndex:number){
        if(_tokenIndex >= 0 && _tokenIndex < this._tokens.length)
            this._mtsDateTokens.splice(_tokenIndex, 1);
    }
}
export class ManPowerAllocation{
    constructor(private _id:string,private _workCategories:Array<WorkCategory>){}
    get isNew():boolean{
        return this._id == '';
    }
    get id():string{
        return this._id;
    }  
    get workCategories():Array<WorkCategory>{
        return this._workCategories;
    }
    set workCategories(cat:Array<WorkCategory>){
        this._workCategories = cat;
    }
}
export class FooterData{
    constructor(private footer_data:string,private footer_back:string){}
    get footerData():string{
        return this.footer_data;
    }
    get footerBack():string{
        return this.footer_back
    }
    set footerData(dt:string){
        this.footer_data = dt;
    }
    set footerBack(dt:string){
        this.footer_back = dt;
    }
}
export class TaskAllocation{    
    private _monthDate:Date;
    constructor(private _id:string,private _monthDateNum:number,private _dayTokens:Array<TaskDayToken>,private _docTs:number){}
    get isNew():boolean{
        return this._id == '';
    }
    get id():string{
        return this._id;
    } 
    get monthDateNum():number{
        return this._monthDateNum;
    }
    get monthDate():Date{
        if(this._monthDateNum>0) return new Date(this._monthDateNum);
        return null;
    } 
    get docTs():number{
        return this._docTs;
    }
    set monthDateNum(_dtNum:number){
        this._monthDateNum = _dtNum;
    }
    set monthDate(date:Date){
        this._monthDate = date;
        this._monthDateNum = date.getTime();
    }
    set dayTokens(_dTokens:Array<TaskDayToken>){
        this._dayTokens = _dTokens;
    }
    get dayTokens():Array<TaskDayToken>{
        return this._dayTokens
    }
    set dayToken(_dt:TaskDayToken){
        var isFound = false;        
        if(this._dayTokens.length>0){
            for(var i=0;i<this._dayTokens.length;i++){
                if(this._dayTokens[i].selDate == _dt.selDate){
                    isFound = true;
                    this._dayTokens[i].dateTokens = _dt.dateTokens
                }
            }
        }        
        if(isFound == false){
            this._dayTokens.push(_dt)
        }

    }
    addDateToken(_daySelected:Date,_dToken:TaskLinked = null){        
        let _tmpDate:Date = new Date(_daySelected.getTime());
        let _tmpIndex:number = this._dayTokens.findIndex((_tmpObj:TaskDayToken) => {
            return _tmpObj.selDate.getDate() == _tmpDate.getDate() &&
                   _tmpObj.selDate.getMonth() == _tmpDate.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _tmpDate.getFullYear();
        });
        if(_tmpIndex >= 0){
            if(_dToken!=null)
                this._dayTokens[_tmpIndex].addToken(_dToken);
        }
        else{
            if(_dToken!=null)
                this._dayTokens.push(new TaskDayToken(_tmpDate,[_dToken]));
            else 
                this._dayTokens.push(new TaskDayToken(_tmpDate,[]));

       }
    }
    getDateToken(_daySelected:Date):TaskDayToken{
      //  console.log(this._dayTokens)
        return this._dayTokens.find((_tmpObj:TaskDayToken) => {
            return _tmpObj.selDate.getDate() == _daySelected.getDate() &&
                   _tmpObj.selDate.getMonth() == _daySelected.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _daySelected.getFullYear();
        });
    }
}
export class TaskDayToken{
    constructor(private _selDate:Date,private _tokens:Array<TaskLinked>){}
    get selDate():Date{
        return this._selDate;
    }
    get dateTokens():Array<TaskLinked>{
        return this._tokens;
    }
    set selDate(_dt:Date){
        this._selDate = _dt;
    }
    set dateTokens(_tmpTokens:Array<TaskLinked>){
        this._tokens = _tmpTokens;
    }
    
    set clearDayToken(_dt:Array<any>){
        this._tokens=[];
    }
    addToken(_tmpToken:TaskLinked){
        this._tokens.push(_tmpToken);
    }
    removeToken(_tokenIndex:number){
        if(_tokenIndex >= 0 && _tokenIndex < this._tokens.length)
            this._tokens.splice(_tokenIndex, 1);
    }
}
export class TaskLinked{
    constructor(private _productLineId:string,private _productLineName:string,
        private _poleELId:string,private _poleELName:string,private _users:Array<addUser>,private _quantity:string){}
    get productLineId():string{
        return this._productLineId;
    }
    get productLineName():string{
        return this._productLineName;
    }
    get poleELId():string{
        return this._poleELId;
    }
    get poleELName():string{
        return this._poleELName
    }
    get users():Array<addUser>{
        return this._users;
    }
    get quantity():string{
        return this._quantity
    }
    set poleELId(_setVal:string){
        this._poleELId = _setVal;
    }
    set quantity(qt:string){
        this._quantity = qt
    }
    addUser(_newUser:addUser){
        this._users.push(_newUser);
    }
    removeUser(_email:string){
        for(var i=0;i<this._users.length;i++){
            if(this._users[i].email.trim().toLowerCase() == _email.trim().toLowerCase()){
                this._users.splice(i,1);
                i--;
            }
        }
    }
}
export class WorkCategory{
    constructor(private _workCategoryId:string,private _workCategoryName:string,private _orderNo:number,private _task:Array<TaskList>,private _isActive:boolean){ }
      
    get workCategoryId():string{
        return this._workCategoryId;
    }
    get workCategoryName():string{
        return this._workCategoryName;
    }
    get orderNo():number{
        return this._orderNo;
    }
    get task():Array<TaskList>{
        return this._task;
    }
    get isActive():boolean{
        return this._isActive;
    }
    set workCategoryId(id:string){
        this._workCategoryId = id;
    }
    set workCategoryName(name:string){
        this._workCategoryName = name;
    }
    set orderNo(no:number){
        this._orderNo = no;
    }
    set task(tsk:Array<TaskList>){
        this._task = tsk;
    }
    set isActive(fl:boolean){
        this._isActive = fl;
    }
}
export class PoleStockReview{
    constructor(private _id:string,private _monthDateNum:number,private _plan:string, private _dayTokens:Array<PSRDayToken>,private _docTs:number ){}
    get isNew():boolean{
        return this._id == '';
    }
    get id():string{
        return this._id;
    }
    get monthDateNum():number{
        return this._monthDateNum;
    }
    get monthDate():Date{
        if(this._monthDateNum>0) return new Date(this._monthDateNum);
        return null;
    }
    get plan():string{
        return this._plan;
    }
    get dayTokens():Array<PSRDayToken>{
        return this._dayTokens;
    }
    get docTs():number{
        return this._docTs;
    }
    set monthDateNum(_mName:number){
        this._monthDateNum = _mName;
    }
    set plan(_p:string){
        this._plan = _p;
    }
    set dayTokens(_dTokens:Array<PSRDayToken>){
        this._dayTokens = _dTokens;
    }

    addDateToken(_daySelected:Date,_dToken:PSRToken = null){
        
        let _tmpDate:Date = new Date(_daySelected.getTime());
        let _tmpIndex:number = this._dayTokens.findIndex((_tmpObj:PSRDayToken) => {
            return _tmpObj.selDate.getDate() == _tmpDate.getDate() &&
                   _tmpObj.selDate.getMonth() == _tmpDate.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _tmpDate.getFullYear();
        });
        if(_tmpIndex >= 0){
            if(_dToken!=null)
                this._dayTokens[_tmpIndex].addToken(_dToken);
        }
        else{
            if(_dToken!=null)
                this._dayTokens.push(new PSRDayToken(_tmpDate,[_dToken]));
            else 
                this._dayTokens.push(new PSRDayToken(_tmpDate,[]));

       }
    }

    getDateToken(_daySelected:Date):PSRDayToken{
        return this._dayTokens.find((_tmpObj:PSRDayToken) => {
            return _tmpObj.selDate.getDate() == _daySelected.getDate() &&
                   _tmpObj.selDate.getMonth() == _daySelected.getMonth() &&
                   _tmpObj.selDate.getFullYear() == _daySelected.getFullYear();
        });
    }
}

export class PSRDayToken{
    constructor(private _selDate:Date,private _tokens:Array<PSRToken>){

    }

    get selDate():Date{
        return this._selDate;
    }
    get dateTokens():Array<PSRToken>{
        return this._tokens;
    }
    set dateTokens(_tmpTokens:Array<PSRToken>){
        this._tokens = _tmpTokens;
    }
    addToken(_tmpToken:PSRToken){
        this._tokens.push(_tmpToken);
    }
    removeToken(_tokenIndex:number){
        if(_tokenIndex >= 0 && _tokenIndex < this._tokens.length)
            this._tokens.splice(_tokenIndex, 1);
    }
}


export class DPHToken{
    public _date:Date;
    public _creationDate:Date;
    public _isSeverityModified:boolean = false;
    constructor(private _rowId:string,private _productId:string,private _productType:string, private _customerId:string,private _ps:string,
                private _quantity:number,private _shortage:string,private _status:string,private _creationDateNum:number,private _shortageNotes:string,private _severityValue:SeverityStatus){ 

    }
    get rowId():string{
        return this._rowId;
    }
   
    get productType():string{
        return this._productType
    }
    get shortage():string{
        return this._shortage
    }
    get productId():string{
        return this._productId;
    }
    get ps():string{
        return this._ps;
    }
    get customerId():string{
        return this._customerId;
    }
    get quantity():number{
        return this._quantity;
    }
    get creationDate():number{         
        return this._creationDateNum;
    }

    get status():string{
        return this._status;
    }
    get shortageNotes():string{
        return this._shortageNotes
    }
    get severityValue():SeverityStatus{
        return this._severityValue
    }
    get isShortage():boolean{
        if(this.shortage == "yes") return true;
        return false;
    }
    public isShortageStatus(_checkStatus:SeverityStatus){
        if(_checkStatus == this.severityValue) return true;
        return false;
    }


    set productType(st:string){
        this._productType = st;
    }
    set shortage(st:string){
        this._shortage= st;
    }
    set productId(_pid:string){
        this._productId = _pid;
    }
    set customerId(_cid:string){
        this._customerId = _cid;
    }
    set ps(_id:string){
        this._ps = _id;
    }
    set quantity(_q:number){
        this._quantity = _q;
    }
    set status(st:string){
        this._status = st;
    }
    set creationDate(dt:number){
        this._creationDateNum = dt;
        this._creationDate = new Date(dt);
    }
    set shortageNotes(st:string){
        this._shortageNotes = st;
    }
    set severityValue(SetVal:SeverityStatus){
        this._isSeverityModified = true;
        this._severityValue = SetVal;
    }

    cloneSelf():DPHToken{
        let _tmpObj:DPHToken = new DPHToken(this.rowId, this._productId,this._productType,this._customerId,this._ps,this._quantity,this._shortage, this._status,this._creationDateNum,this._shortageNotes,this._severityValue);
        return _tmpObj;
    }
}

export class MSCToken{
    public _resolutionDate:Date;
    public _creationDate:Date;
    constructor(private _materialShortageId:string,private _particulars:string, private _resolutionDateNum:number,private _ownerName:string,private _status:string,private _creationDateNum:number){ }
    
    get materialShortageId():string{
        if(this._materialShortageId == null) this._materialShortageId = GenService.getGUID();
        return this._materialShortageId
    }
    get particulars():string{
        return this._particulars;
    }
    get resolutionDateNum():number{
        return this._resolutionDateNum;
    }
    get status():string{
        return this._status;
    }
    get resolutionDate():Date{
        if(this._resolutionDateNum>0) return new Date(this._resolutionDateNum);
      //  if(!this._resolutionDate) return this._resolutionDate;
        return null;
    }
    get ownerName():string{
        return this._ownerName;
    }
    // get materialShortageSrc():string{
    //     return this._materialShortageSrc;
    // }
    get creationDate():number{
        return this._creationDateNum
    }

    set materialShortageId(_tempShortageId:string){
         this._materialShortageId = _tempShortageId;
    }
    // set materialShortageSrc(_tempShortageSrc:string){
    //     this._materialShortageSrc = _tempShortageSrc;    
    // }
    set particulars(_pid:string){
        this._particulars = _pid;
    }
    set status(_pid:string){
        this._status = _pid;
    }
    set resolutionDateNum(_cid:number){
        this._resolutionDateNum = _cid;
    }
    set resolutionDate(_dt:Date){
        this._resolutionDate = _dt;
        this._resolutionDateNum = (_dt ? _dt.getTime() : 0);
    }
    set ownerName(_on:string){
        this._ownerName = _on;
    }
    set creationDate(dt:number){
        this._creationDateNum = dt;
        this._creationDate = new Date(dt)
    }
    cloneSelf():MSCToken{
        return new MSCToken(this._materialShortageId,this._particulars,this._resolutionDateNum,this._ownerName,this._status,this._creationDateNum);
    }
}

export class DSPToken{
    public _date:Date;
    public _creationDate:Date;
    constructor(private _type:string, private _equipment:string,private _customerName:string,private _saleOrder:string, private _lineItem:string, private _ps:string,
        private _quantity:number,private _dateNum:number,private _status:string, private _remark:string,private _dispatchStatus:string, private _disRemarks:string,private _creationDateNum:number){ }

    get type():string{
        return this._type;
    }
    get dateNum():number{
        return this._dateNum;
    }
    get date():Date{
        if(this._dateNum>0) return new Date(this._dateNum);
        return null;
    }
    get equipment():string{
        return this._equipment;
    }
    get customerName():string{
        return this._customerName;
    }
    get quantity():number{
        return this._quantity;
    }
    get saleOrder():string{
        return this._saleOrder;
    }
    get lineItem():string{
        return this._lineItem;
    }
    get ps():string{
        return this._ps;
    }
    get dispatchStatus():string{
        return this._dispatchStatus;
    }
    get status():string{
        return this._status;
    }
    get remark():string{
        return this._remark;
    }
    get disRemarks():string{
        return this._disRemarks;
    }
    get creationDate():number{
        return this._creationDateNum
    }
    set type(type:string){
        this._type = type;
    }
    set equipment(eq:string){
        this._equipment = eq;
    }
    set customerName(_cid:string){
        this._customerName = _cid;
    }
    set quantity(qty:number){
        this._quantity = qty;
    }
    set saleOrder(cb:string){
        this._saleOrder = cb;
    }
    set lineItem(str:string){
        this._lineItem = str;
    }
    set ps(di:string){
        this._ps = di;
    }
    set dispatchStatus(st:string){
        this._dispatchStatus = st;
    }
    set dateNum(_cid:number){
        this._dateNum = _cid;
    }
    set date(_dt:Date){
        this._date = _dt;
        this._dateNum = _dt.getTime();
    }
    set status(st:string){
        this._status = st;
    }
    set remark(rmk:string){
        this._remark = rmk;
    }
    set disRemarks(rm:string){
        this._disRemarks = rm;
    }
    set creationDate(_dt:number){
        this._creationDateNum = _dt;
        this._creationDate = new Date(_dt);
    }

    cloneSelf():DSPToken{
        return new DSPToken(this._type, this._equipment,this._customerName,this._saleOrder, this._lineItem,this._ps,this._quantity,this._dateNum,this._status,this._remark,this._dispatchStatus,this._disRemarks,this._creationDateNum);
    }

}

export class CIPToken{
    public _date:Date;
    private _createdDate:Date;
    constructor(private _productName:string, private _customerName:string,private _inspectionDoneBy:string,private _quantity:number,private _witnessQuantity:number,
                private _cb:string,private _dateNum:number,private _respPrsn:string,private _createdDateNum:number){ }

    get productName():string{
        return this._productName;
    }
    get dateNum():number{
        return this._dateNum;
    }
    get date():Date{
        if(this._dateNum>0) return new Date(this._dateNum);
     //   if(!this._date) return this._date;
        return null;
    }
    get customerName():string{
        return this._customerName;
    }
    get inspectionDoneBy():string{
        return this._inspectionDoneBy;
    }
    get quantity():number{
        return this._quantity;
    }
    get witnessQuantity():number{
        return this._witnessQuantity;
    }
    get cb():string{
        return this._cb;
    }
    get respPrsn():string{
        return this._respPrsn;
    }
    get creationDate():number{
        return this._createdDateNum
    }
    set productName(prdname:string){
        this._productName = prdname;
    }
    set customerName(_cid:string){
        this._customerName = _cid;
    }
    set inspectionDoneBy(_insp:string){
        this._inspectionDoneBy = _insp;
    }
    set quantity(qty:number){
        this._quantity = qty;
    }
    set witnessQuantity(qty:number){
        this._witnessQuantity = qty;
    }
    set cb(cb:string){
        this._cb = cb;
    }
    set respPrsn(rspPrsn:string){
        this._respPrsn = rspPrsn;
    }
    set dateNum(_cid:number){
        this._dateNum = _cid;
    }
    set date(_dt:Date){
        this._date = _dt;
        this._dateNum = _dt.getTime();
    }
    set creationDate(_dt:number){
        this._createdDateNum = _dt;
        this._createdDate = new Date(_dt);
    }

    cloneSelf():CIPToken{
        return new CIPToken(this._productName, this._customerName,this._inspectionDoneBy,this._quantity,this._witnessQuantity,
                            this._cb,this._dateNum,this._respPrsn,this._createdDateNum)
    }
}

export class GSPToken{
    public _date:Date;
    private _createdDate:Date
    public _isSeverityModified:boolean = false;
    constructor(private _rowId:string,private _productName:string,private _productType:string, private _customerName:string,private _ps:string,private _quantity:number,private _shortage:string,private _status:string,private _shortageNotes:string,private _createdDateNum:number,private _severityValue:SeverityStatus){
     }
    get rowId():string{
        return this._rowId;
    }
    get productName():string{
        return this._productName;
    }
    get productType():string{
        return this._productType;
    }
    get ps():string{
        return this._ps
    }
    get shortage():string{
        return this._shortage
    }
    get customerName():string{
        return this._customerName;
    }
    get quantity():number{
        return this._quantity;
    }
    get status():string{
        return this._status;
    }
    get creationDate():number{
      return  this._createdDateNum
    }
    get shortageNotes():string{
        return this._shortageNotes;
    }

    get isShortage():boolean{
        if(this.shortage == "yes") return true;
        return false;
    }
    public isShortageStatus(_checkStatus:SeverityStatus){
        if(_checkStatus == this.severityValue) return true;
        return false;
    }

   
    get severityValue():SeverityStatus{
        return this._severityValue
    }
    set productName(prdname:string){
        this._productName = prdname;
    }
    set productType(st:string){
        this._productType = st;
    }
    set customerName(_cid:string){
        this._customerName = _cid;
    }
    set quantity(qty:number){
        this._quantity = qty;
    }
    set status(st:string){
        this._status = st;
    }
    set ps(ps:string){
        this._ps = ps
    }
    set shortage(st:string){
        this._shortage = st
    }
    set shortageNotes(st:string){
        this._shortageNotes = st;
    }
    set creationDate(dt:number){
        this._createdDateNum = dt;
        this._createdDate = new Date(dt)
    }
    set severityValue(SetVal:SeverityStatus){
        this._isSeverityModified = true;
        this._severityValue = SetVal;
    }

    cloneSelf():GSPToken{
        let _tmpObj:GSPToken = new GSPToken(this.rowId,this._productName,this._productType, this._customerName,this._ps,this._quantity,this._shortage,this._status,this._shortageNotes,this._createdDateNum,this._severityValue);

        return _tmpObj;
    }
}

export class IQIToken{
    public _targetDate:Date;
    private _createdDate:Date;
    public _isSeverityModified:boolean = false;
    constructor(private _rowId:string,private _productName:string,private _productType:string,private _ps:string,private _productDesc:string,private _quantity:string, private _issueRelated:string,
        private _supplierName:string,private _ncrCapturing:string,
        private _issueCapturing:string,private _defectCategory:string,private _defectSubCategory1:string,
        private _defectSubCategory2:string,private _defectSubCategory3:string,private _rootCause:string,private _dispositionDecision:string,
        private _actionDecided:string,private _preventiveAction:string,private _respPrsn:string,private _targetDateNum:number
       ,private _status:string,private _shortageNotes:string,private _createdDateNum:number,private _severityValue:SeverityStatus,private _selDate:Date){ 
            if(this._rowId == null || this._rowId == ""){
                this._rowId = GenService.getGUID();
            }
        }
    get rowId():string{
        return this._rowId;
    }
    get productName():string{
        return this._productName;
    }
    get productType():string{
        return this._productType;
    }
    get ps():string{
        return this._ps;
    }
    get productDesc():string{
        return this._productDesc;
    }
    get quantity():string{
        return this._quantity
    }
    get issueRelated():string{
        return this._issueRelated;
    }
    get supplierName():string{
        return this._supplierName;
    }
    get ncrCapturing():string{
        return this._ncrCapturing;
    }
    get issueCapturing():string{
        return this._issueCapturing;
    }
    get defectCategory():string{
        return this._defectCategory
    }
    get defectSubCategory1():string{
        return this._defectSubCategory1
    }
    get defectSubCategory2():string{
        return this._defectSubCategory2
    }
    get defectSubCategory3():string{
        return this._defectSubCategory3
    }
    get rootCause():string{
        return this._rootCause;
    } 
    get dispositionDecision():string{
        return this._dispositionDecision
    } 
    get actionDecided():string{
        return this._actionDecided
    }
    get preventiveAction():string{
        return this._preventiveAction;
    }
    get respPrsn():string{
        return this._respPrsn
    }
    get targetDateNum():number{
        return this._targetDateNum
    }
    get targetDate():Date{
        if(this._targetDateNum>0) return new Date(this._targetDateNum);
        return null;
    }
    get status():string{
        return this._status
    }
    get shortageNotes():string{
        return this._shortageNotes
    }
    get creationDateNum():number{
        return this._createdDateNum;
    }
    set creationDateNum(_SetVal:number){
        this._createdDateNum = _SetVal;
    }
    get createdDate():Date{
        if(this._createdDateNum>0) return new Date(this._createdDateNum);
        return null;
    }
    get severityValue():SeverityStatus{
        return this._severityValue
    }
    get selDate():Date{
        return this._selDate;
    }
    public isSeverityStatus(_checkStatus:SeverityStatus){
        if(_checkStatus == this.severityValue) return true;
        return false;
    }
    set rowId(_id:string){
        this._rowId = _id;
    }
    set productName(prdname:string){
        this._productName = prdname;
    }
    set productType(St:string){
        this._productType = St;
    }
    set ps(ps:string){
        this._ps = ps;
    }
    set productDesc(desc:string){
        this._productDesc = desc;
    }
    set quantity(qt:string){
        this._quantity = qt;
    }
    set issueRelated(_cid:string){
        this._issueRelated = _cid;
    }
    set supplierName(ad:string){
        this._supplierName = ad;
    }
    set ncrCapturing(_cid:string){
        this._ncrCapturing = _cid;
    }
    set issueCapturing(pr:string){
        this._issueCapturing = pr;
    }
    set defectCategory(prdname:string){
        this._defectCategory = prdname;
    }
    set defectSubCategory1(_cid:string){
        this._defectSubCategory1 = _cid;
    }
    set defectSubCategory2(ad:string){
        this._defectSubCategory2 = ad;
    }
    set defectSubCategory3(_cid:string){
        this._defectSubCategory3 = _cid;
    }
    set rootCause(cs:string){
        this._rootCause = cs;
    }
    set actionDecided(act:string){
        this._actionDecided =  act;
    }
    set preventiveAction(act:string){
        this._preventiveAction = act;
    }
    set respPrsn(res:string){
        this._respPrsn = res;
    }
    set targetDateNum(_cid:number){
        this._targetDateNum = _cid;
    }
    set targetDate(_dt:Date){
        this._targetDate = _dt;
        this._targetDateNum = _dt.getTime();
    }
    set dispositionDecision(pr:string){
        this._dispositionDecision = pr;
    }
    set status(st:string){
        this._status = st;
    }
    set shortageNotes(st:string){
        this._shortageNotes = st;
    }
    set creationDate(dt:number){
        this._createdDateNum = dt;
        this._createdDate = new Date(dt);
    }
    set severityValue(SetVal:SeverityStatus){
        this._isSeverityModified = true;
        this._severityValue = SetVal;
    }
    cloneSelf():IQIToken{
        return new IQIToken(this.rowId,this._productName,this._productType,this._ps,this._productDesc,this._quantity,this._issueRelated,this._supplierName,this._ncrCapturing,
            this._issueCapturing,this._defectCategory,this._defectSubCategory1,this._defectSubCategory2,this._defectSubCategory3,
            this._rootCause,this._dispositionDecision,this._actionDecided,this._preventiveAction,this._respPrsn,
            this._targetDateNum,this._status,this._shortageNotes,this._createdDateNum,this._severityValue,this.selDate);
    }
}

export class PSMToken{
    private _createdDate:Date;
    constructor(private _productName:string, private _scheduleMnth:string,private _tillDatePrdction:string,private _balanceQty:string,
        private _ystrdyProductin:string,private _tdayProdctonPlan:string,private _dateTestedQty:string,private _dateGreenSticker:string,private _balanceGreenStickerQty:string,private _createdDateNum:number){ }

    get productName():string{
        return this._productName;
    }
    get scheduleMnth():string{
        return this._scheduleMnth;
    }
    get tillDatePrdction():string{
        return this._tillDatePrdction;
    }
    get balanceQty():string{
        var _tmpSchMnth = Number(this._scheduleMnth);
        var _tmpTillDateProduction = Number(this._tillDatePrdction);
        if(isNaN(_tmpTillDateProduction)) _tmpTillDateProduction = 0;

        if(isNaN(_tmpSchMnth)){
            this._balanceQty = '-';
        }
        else{
            this._balanceQty = (_tmpSchMnth - _tmpTillDateProduction) + '';
        }
        return this._balanceQty;
    }
    get ystrdyProductin():string{
        return this._ystrdyProductin;
    }
    get tdayProdctonPlan():string{
        return this._tdayProdctonPlan;
    }
    get dateTestedQty():string{
        return this._dateTestedQty;
    }
    get dateGreenSticker():string{
        return this._dateGreenSticker;
    }
    get balanceGreenStickerQty():string{
        var _tmpSchMnth = Number(this._scheduleMnth);
        var _tmpTillDateGreenSticker = Number(this._dateGreenSticker);
        if(isNaN(_tmpTillDateGreenSticker)) _tmpTillDateGreenSticker = 0;

        if(isNaN(_tmpSchMnth)){
            this._balanceGreenStickerQty = '-';
        }
        else{
            this._balanceGreenStickerQty = (_tmpSchMnth - _tmpTillDateGreenSticker) + '';
        }
        return this._balanceGreenStickerQty
    }
    get creationDate():number{
        return this._createdDateNum
    }
    set productName(prdname:string){
        this._productName = prdname;
    }
    set scheduleMnth(_cid:string){
        this._scheduleMnth = _cid;
    }
    set tillDatePrdction(ad:string){
        this._tillDatePrdction = ad;
    }
    set balanceQty(_cid:string){
        this._balanceQty = _cid;
    }
    set ystrdyProductin(pr:string){
        this._ystrdyProductin = pr;
    }
    set tdayProdctonPlan(_pl:string){
        this._tdayProdctonPlan = _pl;
    }
    set dateTestedQty(_dtq:string){
        this._dateTestedQty = _dtq;
    }
    set dateGreenSticker(_dgs:string){
        this._dateGreenSticker = _dgs;
    }
    set balanceGreenStickerQty(_st:string){
        this._balanceGreenStickerQty = _st;
    }
    set creationDate(dt:number){
        this._createdDateNum = dt;
        this._createdDate = new Date(dt);
    }
    cloneSelf():PSMToken{
        return new PSMToken(this._productName,this._scheduleMnth,this._tillDatePrdction,this._balanceQty,this._ystrdyProductin,this._tdayProdctonPlan,this._dateTestedQty,this._dateGreenSticker,this._balanceGreenStickerQty,this._createdDateNum);
    }
}

export class CCRPSMToken{
    private _targetDate:Date;
    private _closedDate:Date;
    private _createdDate:Date
    constructor(private _ccrpNo:string,private _customer:string,private _reason:string,private _materialDesc:string, private _respPrsn:string,private _targetDateNum:number,private _status:string,private _closedDateNum:number,private _createdDateNum:number){ }

    get ccrpNo():string{
        return this._ccrpNo;
    }
    get customer():string{
        return this._customer;
    }
    get reason():string{
        return this._reason;
    }
    get materialDesc():string{
        return this._materialDesc;
    }
    get respPrsn():string{
        return this._respPrsn;
    }
    get targetDateNum():number{
        return this._targetDateNum;
    }
    get targetDate():Date{
        if(this._targetDateNum>0) return new Date(this._targetDateNum);
        return null;
    }
    get closedDateNum():number{
        return this._closedDateNum;
    }
    get closedDate():Date{
        if(this._closedDateNum>0) return new Date(this._closedDateNum);
        return null;
    }
    get status():string{
        return this._status;
    }
    get createdDate():number{
        return this._createdDateNum;
    }
    set ccrpNo(no:string){
        this._ccrpNo = no;
    }
    set customer(ct:string){
        this._customer = ct;
    }
    set reason(rs:string){
        this._reason = rs;
    }
    set materialDesc(prdname:string){
        this._materialDesc = prdname;
    }
    set respPrsn(_cid:string){
        this._respPrsn = _cid;
    }
    set targetDateNum(_cid:number){
        this._targetDateNum = _cid;
    }
    set targetDate(_dt:Date){
        this._targetDate = _dt;
        this._targetDateNum = _dt.getTime();
    }
    set status(st:string){
        this._status = st;
    }
    set closedDate(_dt:Date){
        this._closedDate = _dt;
        this._closedDateNum = _dt.getTime();
    }
    set closedDateNum(_cid:number){
        this._closedDateNum = _cid;
    }
    set createdDate(_dt:number){
        this._createdDateNum = _dt;
        this._createdDate = new Date(_dt);
    }
    cloneSelf():CCRPSMToken{
        return new CCRPSMToken(this._ccrpNo,this._customer,this._reason,this._materialDesc, this._respPrsn,this._targetDateNum,this._status,this._closedDateNum,this._createdDateNum);
    }
}

export class TaskList{
    constructor(private _taskId:string,private _taskName:string,private _orderNo:number,private _isActive:boolean){}
    get taskId():string{
        return this._taskId;
    }
    get taskName():string{
        return this._taskName;
    }
    get orderNo():number{
        return this._orderNo;
    }
    get isActive():boolean{
        return this._isActive;
    }
    set taskId(id:string){
        this._taskId = id;
    }
    set taskName(nm:string){
        this._taskName = nm;
    }
    set orderNo(no:number){
        this._orderNo = no;
    }
    set isActive(fl:boolean){
        this._isActive = fl;
    }
}
export class addUser{
    constructor(private _email:string,private _displayName:string){}
    get email():string{
        return this._email;
    }
    get displayName():string{
        return this._displayName;
    }
}
export class PSRToken{
    private _createdDate:Date;
    constructor(private _productName:string, private _poleDescPartNo:string, private _quantity:number, private _createdDateNum:number){}
    get productName():string{
        return this._productName;
    }
    get poleDescPartNo():string{
        return this._poleDescPartNo;
    }
    get quantity():number{
        return this._quantity;
    }
    get creationDate():number{
        return this._createdDateNum
    }
    set productName(pn:string){
        this._productName = pn;
    }
    set poleDescPartNo(_pl:string){
       this._poleDescPartNo = _pl;
    }
    set quantity(qn:number){
        this._quantity = qn;
    }
    set creationDate(dt:number){
        this._createdDate = new Date(dt);
        this._createdDateNum = dt;
    }
    cloneSelf():PSRToken{
        return new PSRToken(this._productName,this._poleDescPartNo,this._quantity,this._createdDateNum);
    }
}

export class Employee{
    constructor(private _emp_id:string,private _emp_name:string,private _emp_photo:string,
                private _emp_doj:number,private _emp_initials:string,private _emp_email:string,private _is_enabled:string){

                }
    get Id():string{
        return this._emp_id;
    }
    get Name():string{
        return this._emp_name;
    }
    get PhotoLink():string{
        return this._emp_photo;
    }
    get DateOfJoining():Date{
        if(this._emp_doj > 0){
            return new Date(this._emp_doj);
        }
        return null;
    }
    get Initials():string{
        return this._emp_initials;
    }
    get Email():string{
        return this._emp_email;
    }
    get IsEnabled():string{
        return this._is_enabled
    }
}

export class Legends{
    constructor(private name:string,private id:number,private color:string,private order:number){}
    get legendName(){
        return this.name;
    }
    set legendName(nm:string){
        this.legendName = name;
    }
    get legendId(){
        return this.id;
    }
    set legendId(id:number){
        this.id = id;
    }
    get legendColor(){
        return this.color;
    }
    set legendColor(cl:string){
        this.color = cl;
    }
    get legendOrder(){
        return this.order;
    }
    set legendOrder(or:number){
        this.order = or;
    }
}
export class Def{
    constructor(private _defId:string,private _defName:string,private _orderno:number,private _isActive:boolean){}
    get defId():string{
        return this._defId;
    }
    get defName():string{
        return this._defName;
    }
    get orderno():number{
        return this._orderno;
    }
    get isActive():boolean{
        return this._isActive;
    }
    set defId(id:string){
        this._defId = id;
    }
    set defName(name:string){
        this._defName = name;
    }
    set orderno(no:number){
        this._orderno = no;
    }
    set isActive(flag:boolean){
        this._isActive = flag
    }
}

export class DailyToken{
    constructor(private _date:Date,private _tokens:Array<DailyTokenItem>){

    }

    get selDate():Date{
        return this._date;
    }
    get items():Array<DailyTokenItem>{
        return this._tokens;
    }
}
export class DailyTokenItem{
    constructor(private _display:string,private _idObj:any,private _adOpt:string){

    }
    get name():string{
        return this._display;
    }
    get idObj():any {
        return this._idObj;
    }
    get additionalOption():string{
        return this._adOpt;
    }
}
export class uModule{
    constructor(private _id:string, private _params:Array<uModParameter>){

    }
    get Id():string{
        return this._id;
    }
    get Parameters():Array<uModParameter>{
        return this._params;
    }
    hasWriteAccess(_pid:string):boolean{
        for(var i=0;i<this._params.length;i++){
            if(this._params[i].ParameterId == _pid){
                if(this._params[i].Permission.indexOf('w')>=0)
                    return true;
                else
                    return false;
            }
        }
        return false;
    }
    hasReadAccess(_pid:string):boolean{
        for(var i=0;i<this._params.length;i++){
            if(this._params[i].ParameterId == _pid){
                if(this._params[i].Permission.indexOf('r')>=0)
                    return true;
                else
                    return false;
            }
        }
        return false;
    }
}

export class uModParameter{
    constructor(private _param_id:string,private _permis:string){
    }
    get ParameterId():string{
        return this._param_id;
    }
    get Permission():string{
        return this._permis;
    }
}

export class NWCMPointDef{
    constructor(private _point_id:string,private _pos_left_unit:number,
                private _pos_top_unit:number, private _pos_width_unit:number, 
                private _pos_status:string, private _pos_title:string,private _pos_image_ref:string){

    }
    get PointId():string{
        return this._point_id;
    }
    getLeft(_widthFactor:number):string{
        return (this._pos_left_unit * _widthFactor)+'px';
    }
    getTop(_heightFactor:number):string{
        return (this._pos_top_unit*_heightFactor)+'px';
    }
    getWidth(_widthFactor:number):number{
        return this._pos_width_unit * _widthFactor;
    }
    get Status():string{
        return this._pos_status;
    }
    set Status(_tmpStatus:string){
        this._pos_status = _tmpStatus;
    }
    get Title():string{
        return this._pos_title;
    }
    get ImageRef():string{
        return this._pos_image_ref;
    }
    set ImageRef(_tempImg){
        this._pos_image_ref = _tempImg;
    }
}
export class NWCMStatusMonthData{
    constructor(private _id:string,private _selmonth:string,private _points:NWCMPointData[],private _docTs:number){

    }

    get ID():string{
        return this._id;
    }
    get SelMonth():string{
        return this._selmonth;
    }
    get Points():NWCMPointData[]{
        return this._points;
    }
    get docTs():number{
        return this._docTs;
    }
    
}
export class NWCMPointData{
    constructor(private _kpi_id:string,private _kpi_status:string,private _kpi_image_ref:string,private _history:NWCMHistoryToken[]){

    }
    get KPIId():string{
        return this._kpi_id;
    }
    get KPIStatus():string{
        return this._kpi_status;
    }
    get KPIImageRef():string{
        return this._kpi_image_ref
    }
    get History():NWCMHistoryToken[]{
        return this._history;
    }
}
export class NWCMHistoryToken{
    constructor(private _user:string,private _update_date:Date,private _from_status:string,private _to_status:string){

    }

    get User():string{
        return this._user;
    }
    get UpdateDate():Date{
        return this._update_date;
    }
    get FromStatus():string{
        return this._from_status;
    }
    get ToStatus():string{
        return this._to_status;
    }

}
export class e_KpiImage {
    constructor(private _imgId: string, private _imgName: string, private _imgType: string, private _imgBase64: string) {

    }

    get ImageId(): string {
        return this._imgId
    }
    get Name(): string {
        return this._imgName
    }
    get Type(): string {
        return this._imgType
    }
    get Base64Data(): string {
        return this._imgBase64
    }

    set ImageId(_tempId: string) {
        this._imgId = _tempId;
    }

    set Name(_tempName: string) {
        this._imgName = _tempName;
    }
    set Type(_tempType: string) {
        this._imgType = _tempType;
    }
    set Base64Data(_tempData: string) {
        this._imgBase64 = _tempData;
    }
    cloneSelf() {
        return new e_KpiImage(this._imgId, this._imgName, this._imgType, this._imgBase64,
        );
    }

}
export class FinishedGoodsDaily {
    constructor(private _dateNum: number,private _cb:string,private _module:string,private _looseKit:string, private _totalFGoodsQty: string, private _totalRevenue: string,
        private _fgTokens: Array<FinishedGoodsToken>) { }

    get dateNum(): number {
        return this._dateNum;
    }
    get monthNum():number{
        if(this._dateNum && this._dateNum > 0){
            let _selDate:Date = GenService.parseDateString(this._dateNum+'',"YYYYMMDD");
            return Number(GenService.getDateFormatStr(_selDate,"YYYYMM"));
        }
        return null;
    }
    get cb():string{
        return this._cb;
    }
    get module():string{
        return this._module;
    }
    get looseKit():string{
        return this._looseKit;
    }
    get date():Date{
        if(this._dateNum){
            let _tmpDate:Date =  GenService.parseDateString(this._dateNum + '',"YYYYMMDD")
            return _tmpDate;
        }
        return null;
    }
    get totalFGoodsQty(): string {
        return this._totalFGoodsQty;
    }
    get totalRevenue(): string {
        return this._totalRevenue;
    }
    get FGTokens():Array<FinishedGoodsToken>{
        return this._fgTokens;
    }
    set cb(_tempCb:string){
        this._cb = _tempCb;
    }
    set module(_tempModule:string){
        this._module = _tempModule;
    }
    set looseKit(_tempLooseKit:string){
        this._looseKit = _tempLooseKit;
    }

    addFGToken(_fgToken:FinishedGoodsToken){
        this._fgTokens.push(_fgToken);
    }
    getDateToken(_daySelected:Date,_fgDailyArray:Array<FinishedGoodsDaily>):FinishedGoodsDaily{
        return _fgDailyArray.find((_tmpObj:FinishedGoodsDaily) => {
            return _tmpObj.date.getDate() == _daySelected.getDate() &&
                   _tmpObj.date.getMonth() == _daySelected.getMonth() &&
                   _tmpObj.date.getFullYear() == _daySelected.getFullYear();
        });

    }
    getTotal():number{
        let _total =  0;
        if(GenService.IsValidNumber(this._cb) == true){
            _total += parseFloat(this._cb);
        }
        if(GenService.IsValidNumber(this._module) == true){
            _total += parseFloat(this._module);
        }
        if(GenService.IsValidNumber(this._looseKit) == true){
            _total += parseFloat(this._looseKit);
        }
        return _total;
    }
    cloneSelf() {
        let tempFgTokenArray:Array<FinishedGoodsToken> = [];
        this._fgTokens.forEach((_tmpObj:FinishedGoodsToken) =>{
            tempFgTokenArray.push(_tmpObj.cloneSelf());
        })
        return new FinishedGoodsDaily(this._dateNum,this._cb,this._module,this._looseKit, this._totalFGoodsQty, this._totalRevenue, tempFgTokenArray);
    }

}

export class FinishedGoodsToken {
    constructor(private _reg: string, private _customer: string, private _saleOrderNo: string, private _lineItem: string,
        private _psRef: string, private _type: string, private _equipment: string, private _planQty: string,
        private _intakeMonth: string, private _minr: string, private _looseKit: string, private _actualGSdateforVCB: string,
        private _actualModuleReceiptDate: string, private _ageing: string, private _modulePartNos: string, private _targetDispatchDate: string,
        private _actualDispathDate: string, private _remarks: string) {

    }

    get reg():string{
		return this._reg;
	}
	set reg(_SetVal:string){
		this._reg = _SetVal;
	}
	get customer():string{
		return this._customer;
	}
	set customer(_SetVal:string){
		this._customer = _SetVal;
	}
	get saleOrderNo():string{
		return this._saleOrderNo;
	}
	set saleOrderNo(_SetVal:string){
		this._saleOrderNo = _SetVal;
	}
	get lineItem():string{
		return this._lineItem;
	}
	set lineItem(_SetVal:string){
		this._lineItem = _SetVal;
	}
	get psRef():string{
		return this._psRef;
	}
	set psRef(_SetVal:string){
		this._psRef = _SetVal;
	}
	get type():string{
		return this._type;
	}
	set type(_SetVal:string){
		this._type = _SetVal;
	}
	get equipment():string{
		return this._equipment;
	}
	set equipment(_SetVal:string){
		this._equipment = _SetVal;
	}
	get planQty():string{
		return this._planQty;
	}
	set planQty(_SetVal:string){
		this._planQty = _SetVal;
	}
	get intakeMonth():string{
		return this._intakeMonth;
	}
	set intakeMonth(_SetVal:string){
		this._intakeMonth = _SetVal;
	}
	get minr():string{
		return this._minr;
	}
	set minr(_SetVal:string){
		this._minr = _SetVal;
	}
	get looseKit():string{
		return this._looseKit;
	}
	set looseKit(_SetVal:string){
		this._looseKit = _SetVal;
	}
	get actualGSdateforVCB():string{
		return this._actualGSdateforVCB;
	}
	set actualGSdateforVCB(_SetVal:string){
		this._actualGSdateforVCB = _SetVal;
	}
	get actualModuleReceiptDate():string{
		return this._actualModuleReceiptDate;
	}
	set actualModuleReceiptDate(_SetVal:string){
		this._actualModuleReceiptDate = _SetVal;
	}
	get ageing():string{
		return this._ageing;
	}
	set ageing(_SetVal:string){
		this._ageing = _SetVal;
	}
	get modulePartNos():string{
		return this._modulePartNos;
	}
	set modulePartNos(_SetVal:string){
		this._modulePartNos = _SetVal;
	}
	get targetDispatchDate():string{
		return this._targetDispatchDate;
	}
	set targetDispatchDate(_SetVal:string){
		this._targetDispatchDate = _SetVal;
	}
	get actualDispathDate():string{
		return this._actualDispathDate;
	}
	set actualDispathDate(_SetVal:string){
		this._actualDispathDate = _SetVal;
	}
	get remarks():string{
		return this._remarks;
	}
	set remarks(_SetVal:string){
		this._remarks = _SetVal;
	}

    cloneSelf():FinishedGoodsToken{
        return new FinishedGoodsToken(this._reg, this._customer, this._saleOrderNo, this._lineItem,
            this._psRef, this._type, this._equipment, this._planQty,
            this._intakeMonth, this._minr, this._looseKit, this._actualGSdateforVCB,
            this._actualModuleReceiptDate, this._ageing, this._modulePartNos, this._targetDispatchDate,
            this._actualDispathDate, this._remarks);
    }

}

export class DailyDlvyPlanToken{
    constructor(private _type:string, private _equipment:string, private _customer_name:string,
                private _sale_order:string, private _line_item:string, private _ps:string, private _qty:string,
                private _date:string, private _prod_status:string, private _remarks:string, 
                private _dispatch_status:string, private _d_remarks ){
    }
    private _typeSelStatus:ExcelAutoSelect = ExcelAutoSelect.Not_Matched; 
    private _typeId:string = null;
    private _equipSelStatus:ExcelAutoSelect = ExcelAutoSelect.Not_Matched;
    private _equipId:string = null;
    private _customerSelStatus:ExcelAutoSelect = ExcelAutoSelect.Not_Matched;
    private _customerId:string = null;
    private _psSelStatus:ExcelAutoSelect = ExcelAutoSelect.Not_Matched;
    private _psId:string = null;
    private _prodStatusSelStatus:ExcelAutoSelect = ExcelAutoSelect.Not_Matched;
    private _prodStatusId:string = null;
    private _dispatchStatusSelStatus:ExcelAutoSelect = ExcelAutoSelect.Not_Matched;
    private _dispatchStatusId:string = null;


    private _productsListRef:Array<ProductsList> = [];
    private _productTypesRef:Array<Product> = [];
    private _customersRef:Array<Customer> = [];
    private _subProductsRef:Array<subProduct> = [];
    private _typeReadyRef:Array<Type> = [];
    private _dispatchTypeRef:Array<Type> = [];
    public processTokenData(_productTypes:Array<Product>, _productsList:Array<ProductsList>, _customers:Array<Customer>, 
        _subProducts:Array<subProduct>, _typeReady:Array<Type>,_dispatchType:Array<Type>):void{
        this._productTypesRef = _productTypes;
        this._productsListRef = _productsList;
        this._customersRef = _customers;
        this._subProductsRef = _subProducts;
        this._typeReadyRef = _typeReady;
        this._dispatchTypeRef = _dispatchType;

        this.processProductType();
        this.processEquipmentType();
        this.processCustomers();
        this.processPS();
        this.processProductStatus();
        this.processDispatchStatus();

        
    }
    private isPerfectMatchType(_srcValue:string,_cmpValue:string):boolean{
        if(_srcValue.toLowerCase().trim() === _cmpValue.toLowerCase().trim()){
            return true;
        }
        return false;
    }
    private getPartialMatchScore(_srcValue:string,_cmpValue:string):number{
        var _cmpTokens = _cmpValue.toLowerCase().trim().split(" ");
        var _srcTokens = _srcValue.toLowerCase().trim().split(" ");
        if(_cmpTokens.length > 0 && _srcTokens.length > 0){
            var found = 0;
            for(var i=0;i<_cmpTokens.length;i++){
                if(_srcTokens.indexOf(_cmpTokens[i]) >= 0){
                    found++;
                }
            }
            if(found == _cmpTokens.length){
                if(_srcTokens.length > _cmpTokens.length){
                    return 99;
                }
                return 100;
            }
            return (found * 100) / _cmpTokens.length
        }
        return 0;
    }
    private processDispatchStatus(){
        for(var i=0;i<this._dispatchTypeRef.length;i++){
            if(this.isPerfectMatchType(this._dispatchTypeRef[i].typeName, this._dispatch_status) == true){
                this._dispatchStatusId = this._dispatchTypeRef[i].typeId;
                this._dispatchStatusSelStatus = ExcelAutoSelect.Perfect_Match;
                break;
            }
        }
        if(this._dispatchStatusSelStatus != ExcelAutoSelect.Perfect_Match){
            var _matchId = null;
            var _matchScore = 0;
            for(var i=0;i<this._dispatchTypeRef.length;i++){
                var _tmpScore = this.getPartialMatchScore(this._dispatchTypeRef[i].typeName, this._dispatch_status);
                if(_tmpScore == 100){
                    this._dispatchStatusId = this._dispatchTypeRef[i].typeId;
                    this._dispatchStatusSelStatus = ExcelAutoSelect.Partial_Match;
                    _matchId = null;
                    break;
                }
                if(_tmpScore > _matchScore){
                    _matchScore = _tmpScore;
                    _matchId = this._dispatchTypeRef[i].typeId;
                }
            }
            if(_matchId != null){
                this._dispatchStatusId = _matchId;
                this._dispatchStatusSelStatus = ExcelAutoSelect.Partial_Match;
            }
        }
    }
    private processProductStatus(){
        for(var i=0;i<this._typeReadyRef.length;i++){
            if(this.isPerfectMatchType(this._typeReadyRef[i].typeName, this._prod_status) == true){
                this._prodStatusId = this._typeReadyRef[i].typeId;
                this._prodStatusSelStatus = ExcelAutoSelect.Perfect_Match;
                break;
            }
        }
        if(this._prodStatusSelStatus != ExcelAutoSelect.Perfect_Match){
            var _matchId = null;
            var _matchScore = 0;
            for(var i=0;i<this._typeReadyRef.length;i++){
                var _tmpScore = this.getPartialMatchScore(this._typeReadyRef[i].typeName, this._prod_status);
                if(_tmpScore == 100){
                    this._prodStatusId = this._typeReadyRef[i].typeId;
                    this._prodStatusSelStatus = ExcelAutoSelect.Partial_Match;
                    _matchId = null;
                    break;
                }
                if(_tmpScore > _matchScore){
                    _matchScore = _tmpScore;
                    _matchId = this._typeReadyRef[i].typeId;
                }
            }
            if(_matchId != null){
                this._prodStatusId = _matchId;
                this._prodStatusSelStatus = ExcelAutoSelect.Partial_Match;
            }
        }
    }
    private processPS(){
        for(var i=0;i<this._subProductsRef.length;i++){
            if(this.isPerfectMatchType(this._subProductsRef[i].subProductName, this._ps) == true){
                this._psId = this._subProductsRef[i].subProductId;
                this._psSelStatus = ExcelAutoSelect.Perfect_Match;
                break;
            }
        }
        if(this._psSelStatus != ExcelAutoSelect.Perfect_Match){
            var _matchId = null;
            var _matchScore = 0;
            for(var i=0;i<this._subProductsRef.length;i++){
                var _tmpScore = this.getPartialMatchScore(this._subProductsRef[i].subProductName, this._ps);
                if(_tmpScore == 100){
                    this._psId = this._subProductsRef[i].subProductId;
                    this._psSelStatus = ExcelAutoSelect.Partial_Match;
                    _matchId = null;
                    break;
                }
                if(_tmpScore > _matchScore){
                    _matchScore = _tmpScore;
                    _matchId = this._subProductsRef[i].subProductId;
                }
            }
            if(_matchId != null){
                this._psId = _matchId;
                this._psSelStatus = ExcelAutoSelect.Partial_Match;
            }
        }
    }
    private processCustomers(){
        for(var i=0;i<this._customersRef.length;i++){
            if(this.isPerfectMatchType(this._customersRef[i].custName, this._customer_name) == true){
                this._customerId = this._customersRef[i].custId;
                this._customerSelStatus = ExcelAutoSelect.Perfect_Match;
                break;
            }
        }
        if(this._customerSelStatus != ExcelAutoSelect.Perfect_Match){
            var _matchId = null;
            var _matchScore = 0;
            for(var i=0;i<this._customersRef.length;i++){
                var _tmpScore = this.getPartialMatchScore(this._customersRef[i].custName, this._customer_name);
                if(_tmpScore == 100){
                    this._customerId = this._customersRef[i].custId;
                    this._customerSelStatus = ExcelAutoSelect.Partial_Match;
                    _matchId = null;
                    break;
                }
                if(_tmpScore > _matchScore){
                    _matchScore = _tmpScore;
                    _matchId = this._customersRef[i].custId;
                }
            }
            if(_matchId != null){
                this._customerId = _matchId;
                this._customerSelStatus = ExcelAutoSelect.Partial_Match;
            }
        }
    }
    private processProductType(){
        for(var i=0;i<this._productTypesRef.length;i++){
            if(this.isPerfectMatchType(this._productTypesRef[i].productName, this._type) == true){
                this._typeId = this._productTypesRef[i].productId;
                this._typeSelStatus = ExcelAutoSelect.Perfect_Match;
                break;
            }
        }
        if(this._typeSelStatus != ExcelAutoSelect.Perfect_Match){
            var _matchId = null;
            var _matchScore = 0;
            for(var i=0;i<this._productTypesRef.length;i++){
                var _tmpScore = this.getPartialMatchScore(this._productTypesRef[i].productName, this._type);
                if(_tmpScore == 100){
                    this._typeId = this._productTypesRef[i].productId;
                    this._typeSelStatus = ExcelAutoSelect.Partial_Match;
                    _matchId = null;
                    break;
                }
                if(_tmpScore > _matchScore){
                    _matchScore = _tmpScore;
                    _matchId = this._productTypesRef[i].productId;
                }
            }
            if(_matchId != null){
                this._typeId = _matchId;
                this._typeSelStatus = ExcelAutoSelect.Partial_Match;
            }
        }
    }
    private processEquipmentType(){
        if(this._equipSelStatus == ExcelAutoSelect.User_Selection) return;

        for(var i=0;i<this._productsListRef.length;i++){
            if(this._productsListRef[i].productType == this._typeId){
                if(this.isPerfectMatchType(this._productsListRef[i].productName, this._equipment) == true){
                    this._equipId = this._productsListRef[i].productId;
                    this._equipSelStatus = ExcelAutoSelect.Perfect_Match;
                    break;
                }
            }
            
        }
        if(this._equipSelStatus != ExcelAutoSelect.Perfect_Match){
            var _matchId = null;
            var _matchScore = 0;
            for(var i=0;i<this._productsListRef.length;i++){
                if(this._productsListRef[i].productType == this._typeId){
                    var _tmpScore = this.getPartialMatchScore(this._productsListRef[i].productName, this._equipment);
                    if(_tmpScore == 100){
                        this._equipId = this._productsListRef[i].productId;
                        this._equipSelStatus = ExcelAutoSelect.Partial_Match;
                        _matchId = null;
                        break;
                    }
                    if(_tmpScore > _matchScore){
                        _matchScore = _tmpScore;
                        _matchId = this._productsListRef[i].productId;
                    }
                }
            }
            if(_matchId != null){
                this._equipId = _matchId;
                this._equipSelStatus = ExcelAutoSelect.Partial_Match;
            }
        }

    }
    get typeId():string{
        return this._typeId;
    }
    set typeId(_setVal:string){
        this._typeSelStatus = ExcelAutoSelect.User_Selection;
        this._typeId = _setVal;
        this.processEquipmentType();
    }
    get typeSelStatus():ExcelAutoSelect{
        return this._typeSelStatus;
    }
    get equipId():string{
        return this._equipId;
    }
    set equipId(_setVal:string){
        this._equipSelStatus = ExcelAutoSelect.User_Selection;
        this._equipId = _setVal;
    }
    get equipSelStatus():ExcelAutoSelect{
        return this._equipSelStatus;
    }
    get customerId():string{
        return this._customerId;
    }
    set customerId(_setVal:string){
        this._customerSelStatus = ExcelAutoSelect.User_Selection;
        this._customerId = _setVal;
    }
    get customerSelStatus():ExcelAutoSelect{
        return this._customerSelStatus;
    }
    get psId():string{
        return this._psId;
    }
    set psId(_setVal:string){
        this._psSelStatus = ExcelAutoSelect.User_Selection;
        this._psId = _setVal;
    }
    get psSelStatus():ExcelAutoSelect{
        return this._psSelStatus;
    }
    get prodStatusId():string{
        return this._prodStatusId;
    }
    set prodStatusId(_setVal:string){
        this._prodStatusSelStatus = ExcelAutoSelect.User_Selection;
        this._prodStatusId = _setVal;
    }
    get prodStatusSelStatus():ExcelAutoSelect{
        return this._prodStatusSelStatus;
    }
    get dispatchStatusId():string{
        return this._dispatchStatusId;
    }
    set dispatchStatusId(_setVal:string){
        this._dispatchStatusSelStatus = ExcelAutoSelect.User_Selection;
        this._dispatchStatusId = _setVal;
    }
    get dispatchStatusSelStatus():ExcelAutoSelect{
        return this._dispatchStatusSelStatus;
    }
    
    get type():string{
        return this._type;
    }
    
    get equipment():string{
        return this._equipment;
    }
    get customer_name():string{
        return this._customer_name;
    }
    get sale_order():string{
        return this._sale_order;
    }
    get line_item():string{
        return this._line_item;
    }
    get ps():string{
        return this._ps;
    }
    get qty():string{
        return this._qty;
    }
    get qtyNum():number{
        if(this.qty && this.qty != '')
            return parseInt(this._qty,10);
        return 0;
    }
    get date():string{
        return this._date;
    }
    get dateObj():Date{
        return new Date((parseInt(this._date,10) - (25567 + 2))*86400*1000);
    }
    get dateNum():number{
        return this.dateObj.getTime();
    }
    get date_formatted():string{
        return GenService.getDateFormatStr(this.dateObj,"DD-mmm-YYYY");
    }
    get prod_status():string{
        return this._prod_status;
    }
    get remarks():string{
        return this._remarks;
    }
    get dispatch_status():string{
        return this._dispatch_status;
    }
    get d_remarks():string{
        return this._d_remarks;
    }


}

export class GenResponse{
    constructor(private _status:string,private _details:string,private _errorCode:string,private _docId:string){}

    get status():string{
        return this._status;
    }
    get details():string{
        return this._details;
    }
    get errorCode():string{
        return this._errorCode;
    }
    get docId():string{
        return this._docId;
    }
}

export enum SeverityStatus{
    Disturbance = 1,
    Production_Loss = 2,
    Not_A_Concern = 3
}
export enum ExcelAutoSelect{
    Not_Matched = 0,
    Partial_Match = 1,
    Perfect_Match = 2,
    User_Selection = 3

}